import { IUntypedQuery, Topics } from '@zaplify/common';
import { ProspectSearchAutoCompleteFields } from '../sources';

export class GetProspectSearchAutoCompleteQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly field: ProspectSearchAutoCompleteFields, readonly query: string) {
        super();
    }
}
